import { render, staticRenderFns } from "./HomeManage.vue?vue&type=template&id=4cc52016&scoped=true&"
import script from "./HomeManage.vue?vue&type=script&lang=js&"
export * from "./HomeManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc52016",
  null
  
)

export default component.exports